import { Fragment, h } from "preact"
import { ProcessStepProps } from "../../../components/process-step/process-step"
import { FullDollarIcon } from "../../../icons/FullDollar"
import { FullFlameIcon } from "../../../icons/FullFlame"
import { PlusIcon } from "../../../icons/Plus"
import { HappyFaceIcon } from "../../../icons/HappyFace"

export const stepProcessList: ProcessStepProps[] = [
  {
    title: 'Step 1',
    subtitle: 'Earn',
    description: 'Start by earning 8 points per dollar spent at Del Taco. As you level up your status, you can earn up to 12 points per dollar!',
    image: {
      element: <FullDollarIcon color={'white'}></FullDollarIcon>,
      bgColor: '#92AD53',
      width: '50px',
      height: '68px',
      responsive: {
        sm: {
          width: '30px',
          height: '40px'
        }
      }
    }
  },
  {
    title: 'Step 2',
    subtitle: 'Redeem',
    description: 'Redeem your points for Del Taco rewards like food, shakes, or even some swag!',
    image: {
      element: <PlusIcon></PlusIcon>,
      bgColor: '#E59A4B',
      width: '40px',
      height: '40px',
      title: 'Redeem',
      responsive: {
        sm: {
          width: '25px',
          height: '25px'
        }
      }
    }
  },
  {
    title: 'Step 3',
    subtitle: 'Level up',
    description: <Fragment>Level up your status by accumulating points earned in a 6 month period. There are four tiers to reach: <strong>QUESO, SCORCHO, INFERNO & EPIC!</strong></Fragment>,
    image: {
      element: <FullFlameIcon color={'white'}></FullFlameIcon>,
      width: '45px',
      height: '63px',
      bgColor: 'black',
      responsive: {
        sm: {
          width: '30px',
          height: '43px'
        }
      }
    }
  },
  {
    title: 'Step 4',
    subtitle: 'Get Bonuses',
    description: 'Earn 250 bonus points by referring friends! Lookout for events to earn even more points!',
    image: {
      element: <HappyFaceIcon></HappyFaceIcon>,
      bgColor: '#D4483B',
      width: '72px',
      height: '36px',
      responsive: {
        sm: {
          width: '60px',
          height: '26px'
        }
      }
    }
  }
];